import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Navigation } from 'lucide-react';
export const AddressCard = () => {
  const mapsUrl = 'https://maps.app.goo.gl/sdYjK56L4xNR3jRQ7';
  return <section className="w-full bg-be-navy py-12 px-6 sm:px-10" data-id="element-14">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto" data-id="element-15">
        <div className="border border-white/10 rounded-sm bg-white/[0.02] backdrop-blur-sm p-6 sm:p-8 flex flex-col sm:flex-row items-start sm:items-center gap-5 sm:gap-8" data-id="element-16">
          <div className="shrink-0 w-12 h-12 rounded-full bg-be-pink/15 border border-be-pink/30 flex items-center justify-center" data-id="element-17">
            <MapPin size={20} className="text-be-pink" data-id="element-18" />
          </div>

          <div className="flex-1" data-id="element-19">
            <p className="text-be-pink text-[10px] sm:text-xs font-semibold tracking-[0.3em] uppercase mb-2" data-id="element-20">
              Visit Our Clinic
            </p>
            <p className="text-white font-semibold text-base sm:text-lg leading-snug" data-id="element-21">
              3130 Crow Canyon Pl, Suite 180
            </p>
            <p className="text-white/70 text-sm sm:text-base" data-id="element-22">
              San Ramon, CA 94583
            </p>
          </div>

          <a href={mapsUrl} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 text-white font-semibold tracking-[0.15em] uppercase text-xs sm:text-sm border border-be-pink/60 hover:bg-be-pink hover:border-be-pink rounded-sm px-5 py-3 transition-colors whitespace-nowrap" data-id="element-23">
            <Navigation size={14} className="text-be-pink group-hover:text-white transition-colors" data-id="element-24" />
            Get Directions
          </a>
        </div>
      </motion.div>
    </section>;
};